import React from 'react'
import { Box, Divider, List, ListItemText, Popover, useMediaQuery } from '@mui/material'
import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { TopBarListItem } from './TopBarListItem'
import { useTranslation } from 'react-i18next'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircle'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { TopBarMenuItem } from './TopBarMenuItem'
import { createWorkorder } from 'app/workorder/state/workorder/actions'
import { useHasPermission } from 'utils/Subscription/RequiredPermissions'
import { PERMISSION_RMA_READ } from 'utils/Subscription/Permissions'
import { useFeature } from '@cbgms/base/feature-flags'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(1)
    },
    addCircleIcon: {
      paddingRight: 80
    }
  })
)

export const AddOrderReturn: React.FC = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const [hasPermission] = useHasPermission(PERMISSION_RMA_READ)
  const isTopBarUXChangeForTimerEnabled = useFeature('topbar-ux-change-for-timer')
  const isSmallerThanXL = useMediaQuery((theme: Theme) => theme.breakpoints.down('xl'))

  const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const onAdd = async () => {
    const uuid = (await dispatch(createWorkorder({}))).Data.UUID
    history.push(`/orders/${uuid}`)
  }

  return (
    <Box display={{ xs: 'contents' }} onClick={handleClick} style={{ display: 'flex' }}>
      {isTopBarUXChangeForTimerEnabled && isSmallerThanXL ? (
        <TopBarMenuItem badge={0} data-testid='topbar-create-order-return'>
          <AddCircleOutlineIcon />
        </TopBarMenuItem>
      ) : (
        <TopBarMenuItem badge={0} startIcon={<AddCircleOutlineIcon />} data-testid='topbar-create-order-return'>
          Shortcuts
        </TopBarMenuItem>
      )}

      <Popover
        data-testid='create-order-return-popup'
        classes={{
          paper: classes.paper
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        onClose={handleClose}
      >
        <List>
          <TopBarListItem data-testid='create-order' onClick={onAdd}>
            <ListItemText primary={t('Quotation.RestoreBasket')} />
          </TopBarListItem>
          {hasPermission ? (
            <>
              <Divider component='li' />
              <TopBarListItem data-testid='register-return' link='/returns/new' onClick={handleClose}>
                <ListItemText primary={t('global.add_rma')} />
              </TopBarListItem>
            </>
          ) : (
            ''
          )}
        </List>
      </Popover>
    </Box>
  )
}
